<template>
  <v-container class="listContainer">
    <v-card>
      <v-toolbar
        dense
        light
        card
      >
        <v-toolbar-title>
          <img class="toolbarIcons" src="@/assets/img/icons/nodes.png" alt="nodes" />
            {{ node.description.name ? node.description.name : 'Node' }}
          </v-toolbar-title>
      </v-toolbar>
    <v-container>
      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Validator Address</v-list-tile-title>
        <router-link
          class="router-link"
          :to="{ name: 'address', params: {address: node.owner_address }}"
        >
          <v-list-tile-content>{{ node.owner_address }}</v-list-tile-content>
        </router-link>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Active</v-list-tile-title>
        <v-list-tile-content>{{ node.active }}</v-list-tile-content>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Verified</v-list-tile-title>
        <v-list-tile-content>{{ node.verified }}</v-list-tile-content>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">State</v-list-tile-title>
        <v-list-tile-content>{{ node.state }}</v-list-tile-content>
      </v-list-tile>
      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Compensation</v-list-tile-title>
        <v-list-tile-content>{{ node.comp_rate | convertFraction() }}</v-list-tile-content>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Rank</v-list-tile-title>
        <v-list-tile-content>{{ node.rank && node.rank > 23 ? '' : node.rank + 1 }}</v-list-tile-content>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Max Accepted Stakes</v-list-tile-title>
        <v-list-tile-content>
          {{
            parseFloat(node.max_shares).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          }}
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Total Stakes</v-list-tile-title>
        <v-list-tile-content>
          {{
            parseFloat(node.shares).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          }}
        </v-list-tile-content>
      </v-list-tile>
      <!-- <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Updated</v-list-tile-title>
        <v-list-tile-content>{{ node.updated_at }}</v-list-tile-content>
      </v-list-tile> -->
      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Created</v-list-tile-title>
        <v-list-tile-content>
           <span>
            <span>
              {{ node.created_at | moment("utc", "from", "now") }}
            </span>
              ({{ node.created_at | moment("utc", "MMM-DD-YYYY HH:mm:ss A") }} +UTC)
          </span>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Location</v-list-tile-title>
        <v-list-tile-content>{{ node.description.location }}</v-list-tile-content>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Home Page</v-list-tile-title>
        <v-list-tile-content>
          <a :href="node.description.website">
            {{ node.description.website }}
          </a>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Email</v-list-tile-title>
        <v-list-tile-content>{{ node.description.email }}</v-list-tile-content>
      </v-list-tile>

      <!-- <v-list-tile class="listData">
        <v-list-tile-title class="listCategory">Profile</v-list-tile-title>
        <v-list-tile-content>{{ node.description.profile }}</v-list-tile-content>
      </v-list-tile> -->

      <!-- <v-list-tile class="listData inputData">
        <v-list-tile-title class="listCategory">Profile</v-list-tile-title>
          <v-textarea
            v-model="node.description.profile"
            readonly
            full-width
            outline
            class="v-input--is-focused"
          >
          </v-textarea>
        </v-list-tile> -->

      <v-tabs
        class="tableTabs nestedTabs"
        slider-color="primary"
      >
        <v-tab>
          Delegators
        </v-tab>
        <v-tab-item>
          <NodeDelegators
            v-bind:address="node.owner_address"
          />
        </v-tab-item>
       </v-tabs>
    </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import NodeDelegators from './nodeDelegators.vue';

export default {
  name: 'Node',
  computed: {
    ...mapGetters(['node']),
  },
  components: {
    NodeDelegators,
  },
  methods: {
    fetchData(nodeAddress) {
      this.isLoading = true;
      this.$store.dispatch('submitQuery', { query: nodeAddress, type: 'node' });
    },
  },
  watch: {
    '$route.params.address': function (newAddress, oldAddress) {
      this.fetchData(newAddress);
    },
  },
  filters: {
    convertFraction(value) {
      const split = value.split('/');
      const decimal = parseInt(split[0], 10) / parseInt(split[1], 10);
      const percentage = decimal * 100;
      return value.indexOf('/') > -1 ? `${percentage.toFixed(2)}%` : value;
    },
  },
  created() {
    this.fetchData(this.$route.params.address);
  },
};
</script>
